// translation key in the 'tools' namespace
export const MISSING_SELECTION_MESSAGE_KEY =
    'reports.messages.error.missingSelection';

/**
 * A report can only be requested with the same fields the request is built
 * from: at least one rightsholder and one sponsor. Pacing reports take both
 * from the goal.
 */
const hasRequiredSelection = (values: any = {}): boolean => {
    if (values.reportType === 'pacing') {
        return !!values.goal;
    }

    return !!values.rightsholders?.length && !!values.sponsors?.length;
};

export default hasRequiredSelection;
